import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.99996 4.83073V4.12703M7.99996 11.1641V11.8678M9.66663 5.9974C9.36244 5.57672 8.65113 5.18258 7.99996 5.18258C7.23841 5.18258 6.2407 5.50839 6.2407 6.43361C6.2407 8.43726 9.75922 7.59402 9.75922 9.50747C9.75922 10.4257 8.77347 10.8122 7.99996 10.8122C7.34878 10.8122 6.54488 10.4181 6.2407 9.9974M14.3333 7.9974C14.3333 11.4952 11.4978 14.3307 7.99996 14.3307C4.50216 14.3307 1.66663 11.4952 1.66663 7.9974C1.66663 4.49959 4.50216 1.66406 7.99996 1.66406C11.4978 1.66406 14.3333 4.49959 14.3333 7.9974Z",
      stroke: "currentColor",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }